import script from "./AppsTypeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsTypeCard.vue?vue&type=script&setup=true&lang=js"

import "./AppsTypeCard.vue?vue&type=style&index=0&id=46e85a38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e85a38"]])

export default __exports__